export const KEYBOARD = {
  enter: 'Enter',
  esc: 'Escape',
  tab: 'Tab',
  shift: 'Shift',
  space: 'Space',
  arrowUp: 'ArrowUp',
  arrowDown: 'ArrowDown',
};
